import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

function PiechartSales() {
  const data = {
    labels: ['Desktop', 'Mobile', 'Tablet', 'Laptop', 'Other'],
    datasets: [
      {
        label: 'Device Usage',
        data: [1000, 450, 300, 250, 200],
        backgroundColor: ['#1939b5', '#fedc60', '#f2a1a6', '#f6cbc7', '#ff8074'],
        borderColor: '#fff',
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, // إضافة هذه السطر للتحكم في النسبة
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  return (
    <div>
      <div style={{ width: '150px', height: '150px' }}> {/* زيادة الحجم هنا */}
        <Doughnut data={data} options={options} />
      </div>
    </div>
  );
}

export default PiechartSales;